import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
	selector: 'wizard-route-view',
	standalone: true
})
export class WizardRouteViewUpgradeDirective extends UpgradeComponent {
	constructor (
		elementRef: ElementRef,
		injector: Injector
	) {
		super('wizardRouteView', elementRef, injector);
	}
}
